import ReportManifestScreen from './manifest/index';

const routes = [
  {
    path: '/report/manifest',
    component: ReportManifestScreen,
  },
];

export default routes;
